import { IConfig, LessonStructure } from 'ingestion/AIGenerated/types'
import { convertToKiddomHTMLStyle } from 'ingestion/AIGenerated/utilities/utility'
import { createNoteNode } from 'ingestion/nodeCreationHelpers'

export function createNoteWithConfig(
  configKey: string,
  config: IConfig,
  lesson: LessonStructure,
  name?: string,
) {
  const noteContent = config.includes
    ? config.includes.reduce((acc: string, includeKey: string) => {
        if (includeKey.split('|').length > 1) {
          const depth = includeKey.split('|')
          const depth1 = lesson.parts.find((part) =>
            name
              ? part.name?.toUpperCase() === name.toUpperCase()
              : part.name?.includes(depth[0].toUpperCase()),
          )
          if (depth1) {
            const depth2 = depth1.parts?.find((part) => {
              return (
                part.name?.trim().toUpperCase() ===
                depth[1].trim().toUpperCase()
              )
            })
            if (depth2) {
              return acc + depth2.content
            }
          }
        } else {
          const include = lesson.parts.find((part) => {
            return part.name?.includes(includeKey.toUpperCase())
          })
          if (include) {
            return include.content || acc
          }
        }

        return acc
      }, '')
    : config.content

  const value = noteContent
    ? convertToKiddomHTMLStyle({ content: noteContent })?.innerHTML
    : ''
  return createNoteNode({
    title: configKey,
    value: value || '',
    studentFacing: !!config.studentFacing,
  })
}
